import React, {Component} from "react";
import {Input} from "antd";

import "./SAInputSearch.css"

const Search = Input.Search;

class SAInputSearch extends Component {

  render() {
    return (
        <Search {...this.props}/>
    );
  }
}

export default SAInputSearch;



// WEBPACK FOOTER //
// ./src/components/common/input/SAInputSearch.js